<template>
    <div>
        
        <!---->
        <el-card class="box-card">	
            <el-form :inline="true"  :model="formInline" class="demo-form-inline">
                <!--查询区-->
                <el-form-item label="创建时间:" >
                    <el-date-picker
                        v-model="param.startDate"
                        type="date"
                        placeholder="开始时间"
                        value-format="yyyy-MM-dd"
                        :clearable="false" >
                    </el-date-picker>
                    ~
                    <el-date-picker
                        v-model="param.endDate"
                        type="date"
                        placeholder="结束时间"
                        value-format="yyyy-MM-dd"
                        :clearable="false">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="注册时间:">
                    <el-date-picker
                        v-model="param.regStartDate"
                        type="date"
                        placeholder="开始时间"
                        value-format="yyyy-MM-dd"
                        :clearable="false">
                    </el-date-picker>
                    ~
                    <el-date-picker
                        v-model="param.regEndDate"
                        type="date"
                        placeholder="结束时间"
                        value-format="yyyy-MM-dd"
                        :clearable="false">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="广告主:">
                    <el-select  v-model="param.advertiserId" placeholder="请选择广告主" clearable filterable>
                        <el-option v-for="advertiser in advertiserData" :key="advertiser.id" :value="advertiser.id" :label="advertiser.name"></el-option>
                    </el-select>
                </el-form-item>
                <br/>
                <el-form-item label="投放师:">
                    <el-select v-model="param.putMan" placeholder="请选择投放师" clearable filterable>
                        <el-option v-for="putMan in putManData" :key="putMan" :label="putMan" :value="putMan" ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="游戏:">
                    <el-select v-model="param.gameId" placeholder="请选择游戏" clearable filterable>
                        <el-option v-for="game in gameData" :key="game.id" :label="game.gameName" :value="game.id" ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="子渠道:">
                    <el-input v-model="param.channel" placeholder="请输入子渠道"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary"  @click="view" icon="el-icon-search">查询</el-button>
                </el-form-item>
                <!--查询区-->
                <el-button style="float:right;margin-right:20px;margin-top:30px" size="mini"  type="info" icon="el-icon-download" @click="downloadExecl">下载表格</el-button>
                <!--自定义列表区-->
                <el-popover
                placement="bottom"
                width="300"
                trigger="click"
                >
                    <el-tabs tab-position="right" style="height: 300px;">
                        <el-tab-pane style="height:300px;overflow-y:auto;overflow-x:hidden;" label="显示列">
                            <span v-for="(colum, key) in advertiserColumns" :key="key">
                                <el-checkbox    v-model="colum.visible" @change="updateDate">{{colum.label}}</el-checkbox>
                                <br/>
                            </span>  
                        </el-tab-pane>
                        <el-tab-pane style="height:300px;overflow-y:auto;overflow-x:hidden;" label="排序列">
                            <span v-for="(colum, key) in advertiserColumns" :key="key">
                                <el-checkbox    v-model="colum.sortable">{{colum.label}}</el-checkbox>
                                <br/>
                            </span> 
                        </el-tab-pane>
                    </el-tabs>
                    <el-button style="float:right;margin-right:20px;margin-top:30px" size="mini"  slot="reference" type="info" icon="el-icon-notebook-2">自定义列</el-button>
                </el-popover>
                <!--自定义列表区-->
                
            </el-form>
        </el-card>
        <!--表格-->
        <el-table 
            :data="tableData"
            :max-height="hight"
            stripe
            border
            show-summary
            :summary-method="getSummaries"
            v-loading="loading"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
            >
            <el-table-column
            prop="name"
            label="账号"
            width="160"
            fixed
            :show-overflow-tooltip="true"
            align='center'>
            <template slot="header" slot-scope="scope">
            <!--拓展功能区-->
          
                <el-popover
                placement="bottom"
                width="80"
                trigger="click"
                >
                    <el-select v-model="value" size="mini" @change="group()">
                        <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                        :disabled="item.visible">
                        </el-option>
                    </el-select>
                    <el-button  size="mini" type="info" slot="reference" icon="el-icon-menu" >{{value}}</el-button>
                </el-popover>
         
            <!--拓展功能区-->
            </template>
            </el-table-column>
            <el-table-column
            label="投放"
            width="180"
            prop="putMan"
            v-if="value == '账户'"
            >
            <template slot-scope="scope"
            align='center'>
                <el-input v-model="scope.row.putMan" :disabled ="scope.row.putMan1 != ''" @blur="update(scope.row)" placeholder="请输入投放人"></el-input>
            </template>
            </el-table-column>
            <el-table-column
            label="返点"
            width="140"
            prop="rebate"
            v-if="value == '账户'"
            >
            <template slot-scope="scope"
            align='center'>
                <el-input v-model="scope.row.rebate" :disabled ="scope.row.rebate1 != 1" @input="changeRebate(scope.row)"  @blur="updateRebate(scope.row)"  placeholder="请输入返点"></el-input>
            </template>
            </el-table-column>
            <el-table-column 
            v-for="(colum, key) in advertiserColumns" 
            :prop="colum.prop" 
            :key="key" 
            :label="colum.label" 
            align="center"  
            :width="colum.width" 
            :sortable="colum.sortable"
            :show-overflow-tooltip="true"
            v-if="colum.visible" >
            <template slot-scope="scope">
                <span style="margin-left: 10px">{{scope.row[colum.prop]}}</span>
            </template>
			</el-table-column>
        </el-table>
    </div>
</template>
<script>
  import advertiserModel from './models/advertiserModel'
  export default {
    data() {
      return {
        param:{
            channel : "",
            gameId : "",
            startDate : "",
            endDate : "",
            regStartDate : "",
            regEndDate : "",
            advertiserId: "",
            id:"",
            putMan:"",
            group: '账户',
            date :false,
        },
        hight:200,
        loading:true,
        dialogVisible: false,
        tableData: [],
        tableViewData: [],
        advertiserData:[],
        gameData:[],
        putManData:[],
        adTableData:[],
        drawer: false,
        campaignName : 'aaaaa',
        advertiserColumns : advertiserModel.new(),
        options: [{
          value: '账户',
          label: '账户',
          visible: false,
        }, {
          value: '计划',
          label: '计划',
          visible: false,
        }, {
          value: '投放',
          label: '投放',
          visible: false,
        }, {
          value: '素材',
          label: '素材',
          visible: false,
        }, {
          value: '游戏',
          label: '游戏',
          visible: false,
        }],
        value: '账户',
      }
    },
    mounted(){
        this.param.startDate = this.getDay(0);
        this.param.endDate = this.getDay(0);
        this.param.regStartDate = this.getDay(0);
        this.param.regEndDate = this.getDay(0);
        this.view();
        this.viewAdvertisers();
        this.viewGames();
        this.viewPutMans();
    },
    created(){
　　   this.hight=window.innerHeight-300;
    },
    methods: {
        //修改分组规则
        group:function(){
            if(this.value == this.param.group){
                return;
            }
            if(this.value== "素材"){
                this.advertiserColumns[5].visible = false;
            }else{
                this.advertiserColumns[5].visible = true;
            }
            this.tableData = [];
            this.param.group = this.value;
            this.view();
        },
        updateDate:function(){
           if( this.param.date != this.advertiserColumns[0].visible){
               this.tableData = [];
               this.view();
           }
        },
        downloadExecl:function(){
             this.tajax.post(
                "/market/ad/excel",
                JSON.stringify(this.advertiserColumns)+"____"+JSON.stringify(this.param),
                {headers:{'Content-Type':'application/json'},
                 responseType: 'blob'}
            ) .then((res)=>{
                let blob = new Blob([res.data], {type: 'application/vnd.ms-excel;charset=utf-8'})
                let url = window.URL.createObjectURL(blob);
                let aLink = document.createElement("a");
                aLink.style.display = "none";
                aLink.href = url;
                aLink.setAttribute("download", this.param.group+".xls");
                document.body.appendChild(aLink);
                aLink.click();
                document.body.removeChild(aLink); 
                window.URL.revokeObjectURL(url); 
            }).catch(err=>{
                alert(22);
            });
        },
        //修改广告主的投放人
        update:function(row){
            if( row.putMan == null ||  row.putMan ==''){
                return;
            }
            this.$confirm('是否将广告主 '+row.name + ' 的投放人修改为 ' + row.putMan + '?', '提示', {
            confirmButtonText: '是',
            cancelButtonText: '否',
            type: 'warning'
            }).then(() => {
            this.$message({
                type: 'success',
                message: '修改成功!'
            });
            row.putMan1 = row.putMan;
            this.tajax.post(
                "/market/ad/update/put/man?id="+row.id+"&putMan="+row.putMan
            ) .then((res)=>{
                this.viewPutMans();
            }).catch(err=>{
                alert(22);
            });
            
            }).catch(() => {
            this.$message({
                type: 'info',
                message: '已取消修改'
            });
            row.putMan = "";          
            });
            
        },
         //修改广告主的投放人
        updateRebate:function(row){
            if( row.rebate == null ||  row.rebate == '' ||  row.rebate == 1 || isNaN(row.rebate) || row.rebate > 10 || row.rebate < 1){
                return;
            }
            this.$confirm('是否将广告主 '+row.name + ' 的折扣修改为 ' + row.rebate + '?', '提示', {
            confirmButtonText: '是',
            cancelButtonText: '否',
            type: 'warning'
            }).then(() => {
            this.$message({
                type: 'success',
                message: '修改成功!'
            });
            row.rebate1 = row.rebate;
            this.tajax.post(
                "/market/ad/update/rebate?id="+row.id+"&rebate="+row.rebate
            ) .then((res)=>{
            }).catch(err=>{
                alert(22);
            });
            
            }).catch(() => {
            this.$message({
                type: 'info',
                message: '已取消修改'
            });
            row.rebate == 1;          
            });
            
        },
        //修改广告主返点
        changeRebate:function(row){
            if( row.rebate == null ||  row.rebate == '' ||  row.rebate == 1){
                row.rmbCost = row.cost
                return;
            }
            if(isNaN(row.rebate) || row.rebate > 10 && row.rebate < 1){
                this.$message('请输入正确的折扣');
                return;
            }
            row.rmbCost = parseFloat(row.cost/row.rebate).toFixed(2);
        },
        //展示计划
        show:function(row){
            this.campaignName = row.name + " / 计划";
            this.drawer = true;
            this.viewAd(row.id);
        },
        //广告视图
        view:function(){
            this.loading = true;
            this.param.date = this.advertiserColumns[0].visible;
            this.tajax.post(
                "/market/ad/view"
                ,this.$qs.stringify(this.param)
            ) .then((res)=>{
                this.tableData = res.data;
                this.loading = false;
            }).catch(err=>{
                alert(22);
            });
        },
        //广告主下拉
        viewAdvertisers:function(){
            this.tajax.post(
                "/market/advertisers",
            ) .then((res)=>{
                this.advertiserData = res.data;
            }).catch(err=>{
                alert(22);
            });
        },
        //游戏下拉
        viewGames:function(){
            this.tajax.post(
                "/market/games",
            ) .then((res)=>{
                this.gameData = res.data;
            }).catch(err=>{
                alert(22);
            });
        },
        //投放下拉
        viewPutMans:function(){
            this.tajax.post(
                "/market/putMan",
            ) .then((res)=>{
                this.putManData = res.data;
            }).catch(err=>{
                alert(22);
            });
        },
        //汇总方法
        getSummaries:function(param) {
            const { columns, data } = param;
            const sums = [];
            var n = 0;
            var d = 0;
            var c = 0;
            var d = 0;
            var e = 0;
            columns.forEach((column, index) => {
            if (index === 0) {
                sums[index] = '汇总';
                return;
            }
            if(column.property == 'rebate' || column.property == 'putMan'){
                sums[index] = '';
                return;
            }
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
                sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                    return prev + curr;
                } else {
                    return prev;
                }
                }, 0);
                if(column.property=='newUsers'){
                    n = sums[index];
                }
                if(column.property=='regDevices'){
                    d = sums[index];
                }
                if(column.property=='cost'){
                    c = sums[index];
                }
                if(column.property=='totalPrice'){
                    d = sums[index];
                }
                if(column.property=='newRechargePrice'){
                    e = sums[index];
                }
                
                if(column.property =='price'){
                    sums[index] = parseFloat(c/d).toFixed(2)
                }
                if(column.property == 'regPrice'){
                    sums[index] = parseFloat(c/n).toFixed(2);
                }
                if(column.property == 'roi'){
                    sums[index] = parseFloat(e/c*100).toFixed(4)+"%";
                }
                if(column.property == 'totalRoi'){
                    sums[index] = parseFloat(d/c*100).toFixed(4)+"%";
                }
                if(sums[index].toString().length>10){
                    sums[index] = parseFloat(sums[index]).toFixed(2)
                }
            } else {
            }
            });

            return sums;
        },
        getDay:function(day){
        　　var today = new Date();
        　　var targetday_milliseconds=today.getTime() + 1000*60*60*24*day;
        　　today.setTime(targetday_milliseconds); //注意，这行是关键代码
        　　var tYear = today.getFullYear();
        　　var tMonth = today.getMonth();
        　　var tDate = today.getDate();
        　　tMonth = this.doHandleMonth(tMonth + 1);
        　　tDate =  this.doHandleMonth(tDate);
        　　return tYear+"-"+tMonth+"-"+tDate;
        },
        doHandleMonth:function(month){
        　　var m = month;
        　　if(month.toString().length == 1){
          　　m = "0" + month;
        　　}
        　　return m;
        },
    }
  }
</script>


// WEBPACK FOOTER //
// src/toutiao/view.vue